export const CLOUD_FRONT_URL = "https://d6ywjvkyvtau.cloudfront.net/public";
export const STACKED_TOKEN_ICON_PAIR = ["eth/btc"];
